import { createParser, useQueryState } from 'nuqs';
import React, { useTransition } from 'react';

import { FuelTypeList } from '@/services/filters/new-filters.service';

import { isFilterEqual, useResetPage } from '../../utils';
import { FilterBlockGroup } from '../common/filter-block-group';

export const NewFuelTypeFilter: React.FC<{
  fuelTypes: FuelTypeList;
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
}> = ({ fuelTypes, searchQuery, setSearchQuery }) => {
  const [_, startTransition] = useTransition();

  const resetPage = useResetPage();

  // const autoSelectedIdsRef = useRef<Set<number>>(new Set());
  // const prevSearchRef = useRef<string>();

  const [queryFuelTypes, setQueryFuelTypes] = useQueryState(
    'fueltype',
    createParser({
      parse(value) {
        const selected = value ? value.toLowerCase().split(',') : [];

        return fuelTypes?.map((type) => ({
          ...type,
          isSelected: selected.includes(type.value.toLowerCase()),
        })) || [];
      },
      serialize(value) {
        return value
          .filter((v) => v.isSelected)
          .map((v) => v.value)
          .join(',');
      },
      eq: isFilterEqual,
    })
      .withDefault(
        fuelTypes?.map((t) => ({ ...t, isSelected: false })) || [],
      )
      .withOptions({
        startTransition,
        shallow: false,
        history: 'push', 
      }),
  );

  /* --------------------------------------------------
   * USER CLICK
   * -------------------------------------------------- */
  const handleSelect = (filter: (typeof queryFuelTypes)[number]) => {
    if (searchQuery && setSearchQuery) {
      setSearchQuery('');
    }

    // Reset page to 1 when fuel type filters change
    resetPage();

    setQueryFuelTypes((prev) =>
      prev.map((item) =>
        item.id === filter.id
          ? { ...item, isSelected: !item.isSelected }
          : item,
      ),
    );
  };

  return (
    <FilterBlockGroup
      label="Fuel Type"
      filters={queryFuelTypes}
      onSelect={handleSelect}
    />
  );
};
